export default __webpack_public_path__ + "static/media/close.67acd9f9.svg";